import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from "@angular/router";

import swal from 'sweetalert2';

import { AuthService } from '../auth.service';
import { User } from '../../shared/models/user';
import { googleAnalyticsEvent } from '../../shared/helpers/google-analytics-event';
import { matchOtherValidator } from './1-match-other-validator';
import { StoreHelper } from '../../shared/helpers/store.helper';
import { PASSWORD_PATTERN } from '../../shared/validators/password';
declare var $: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  standalone: false
})
export class SignupComponent implements OnInit, OnDestroy {
  signupForm: UntypedFormGroup;
  user: User;
  currentIndex: number = 1;
  carousel: any;
  inputEnabled = true;
  privacyPolicy = false;
  maxIndex: number = 5;
  minIndex: number = 1;
  email: string = '';

  prepopulated = false

  qpListener = null
  showEmailError = false
  submitting = false
  showPasswordA = false;
  showPasswordC = false;

  @ViewChild("activationCode", { static: false }) activationCode: ElementRef;


  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {
    googleAnalyticsEvent('Sign up', 'Sign up started');
  }

  ngOnDestroy(): void {
    if (this.qpListener) {
      this.qpListener.unsubscribe()
    }
  }

  ngOnInit() {

    StoreHelper.removeObject('ratings')

    const activationCode = StoreHelper.getObject('activationCode')

    if (activationCode) {
      this.prepopulated = true
    }

    this.signupForm = new UntypedFormGroup({
      'userData': new UntypedFormGroup(
        {
          'email': new UntypedFormControl(null, [Validators.required, emailValidator]),
          'emailConfirm': new UntypedFormControl(null, [Validators.required, matchOtherValidator('email')]),
          'password': new UntypedFormControl(null, [Validators.required, Validators.pattern(PASSWORD_PATTERN)]),
          'passwordConfirm': new UntypedFormControl(null, [Validators.required, matchOtherValidator('password')]),
          'invitationCode': new UntypedFormControl({ value: activationCode || null, disabled: !!activationCode }, [Validators.required]),
          'privacyPolicy': new UntypedFormControl(null, [Validators.requiredTrue])
        },
        passwordMatchValidator
      )
    });

    this.focusOnInput()


    function passwordMatchValidator(g: any) {
      return g.get('password').value === g.get('passwordConfirm').value ? null : { 'mismatch': true };
    }

    function emailValidator(control: any) {
      // RFC 2822 compliant regex
      if (control.value != null && control.value.match(/[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/)) {
        return null;
      } else {
        return { 'invalidEmailAddress': true };
      }
    }

    this.qpListener = this.route.queryParams.subscribe((queryParams: Params) => {
      if ($.isEmptyObject(queryParams)) {
        this.router.navigate(['/signin']);
      } else {
        this.email = queryParams['email'];
        this.signupForm.patchValue({
          userData: {
            email: this.email
          }
        });
      }
    });

    this.carousel = $('.carousel');
    this.maxIndex = $('.carousel .carousel-inner .carousel-item').length;
    $('.carousel').on('slide.bs.carousel', ($event) => {
      this.currentIndex = $event.to + 1;
      this.resetPasswordVisibility();
    });
    $('.carousel').on('slid.bs.carousel', ($event) => {
      this.inputEnabled = true;
    });
  }

  onBack() {
    this.carousel.carousel('prev');
  }

  onNext() {
    this.carousel.carousel('next');
    this.focusOnInput()
  }

  resetPasswordVisibility() {
    this.showPasswordA = false;
    this.showPasswordC = false;
  }

  focusOnInput() {

    window.setTimeout(() => {
      if ($('input[type=password].ng-pristine:visible').length) {
        window.setTimeout(function () {
          $('input[type=password].ng-pristine:visible').focus()
        }, 199)
        return
      }

      if ($('input[type=text].ng-pristine:visible').length) {
        window.setTimeout(function () {
          $('input[type=text].ng-pristine:visible').focus()
        }, 200)
        return
      }

    }, 1)



  }

  goBackToEmail() {
    this.router.navigate(['/signin']);
  }

  onConfirm(input: any, next = '') {
    if (input === this.signupForm.get('userData.emailConfirm')) {
      this.showEmailError = true
    }

    if (input.valid) {
      this.onNext();
    } else {
      input.markAsTouched();
      this.inputEnabled = true;
      return false;
    }
  }

  onShowPasswordA() {
    this.showPasswordA = !this.showPasswordA;
  }

  onShowPasswordC() {
    this.showPasswordC = !this.showPasswordC;
  }

  onPrivacy() {
    this.privacyPolicy = !this.privacyPolicy;
  }

  onSignup() {
    if (this.submitting) {
      return;
    }
    const tmpUser = new User();
    tmpUser.email = this.signupForm.get('userData.email').value.trim();
    tmpUser.activation_code = this.signupForm.get('userData.invitationCode').value;
    tmpUser.password = this.signupForm.get('userData.password').value;
    if (this.signupForm.valid) {
      this.submitting = true;
      this.authService.signupUser(tmpUser)
        .subscribe(
          (user: any) => {

            if( user.error ){
              this.handleError(user.error.statusText)
              return
            }

            googleAnalyticsEvent('Sign up', 'Sign up complete');
            this.signupForm.reset();
            this.user = user;

            StoreHelper.removeObject('activationCode')
            this.router.navigate(['/start']);
          },
          (error) => {
            this.handleError(error)
          }
        );
      this.inputEnabled = true;
    } else {
      this.inputEnabled = true;
    }

  }

  handleError( error ){
    this.submitting = false;
    googleAnalyticsEvent('Sign up', 'Sign up failed');

    let errorText, titleText;

    if (error === 'This email address has already been registered. Click below to login') {
      errorText = error + '. To reset your password, click on the \"Reset password\" link.';
      titleText = 'Email already registered';
    } else if (error === 'This activation code does not correspond to any registered client.') {
      errorText = error;
      titleText = 'Invalid/expired invitation code';
    }else{
      errorText = error;
      titleText = "An error occured"
    }

    swal({
      title: titleText,
      html: errorText,
      showCloseButton: true,
      customClass: 'custom-swal2-hook'
    })
  }

  onKeyDownFunction(event, input: any, counter: number) {
    if (event.keyCode == 13) {
      event.preventDefault();
      this.inputEnabled = false;
      if (counter != 6) {
        return this.onConfirm(input, '');
      } else {
        this.onSignup();
      }
    }
  }
}
